<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<mat-accordion id="Interpretations">
  <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
    <mat-expansion-panel-header class="ia-mat-panel template-3-mat-panel">
      <div
        class="save_title w-100 d-flex align-items-center gap-2 justify-content-between"
      >
        <mat-panel-title *ngIf="tabName == 'Interpretation'">
          <span class="text-header inc-f"> INTERPRETATION {{ tab }} </span>
          <span
            *ngIf="versionHistoryData.isVersonHistory"
            class="marking-changed-fields"
            >Version {{ versionHistoryData.versionNo }}
          </span>
        </mat-panel-title>
        <mat-panel-title *ngIf="tabName == 'Judgement'">
          <span class="text-header inc-f"> JUDGEMENT {{ tab }} </span>
          <span
            *ngIf="versionHistoryData.isVersonHistory"
            class="marking-changed-fields"
            >Version {{ versionHistoryData.versionNo }}
          </span>
        </mat-panel-title>
        <mat-panel-title *ngIf="tabName == 'Approach'">
          <span class="text-header inc-f"> APPROACH {{ tab }} </span>
          <span
            *ngIf="versionHistoryData.isVersonHistory"
            class="marking-changed-fields"
            >Version {{ versionHistoryData.versionNo }}
          </span>
        </mat-panel-title>
        <span
          *ngIf="!versionHistoryData.isVersonHistory"
          class="cursor-pointer text-primary cursor-pointer"
          (click)="openDialog(tabName); $event.stopPropagation()"
          ><i class="fa fa-history text-dark"></i> Version History
        </span>
        <button
          *ngIf="!versionHistoryData.isVersonHistory"
          class="save_btn text-primary cursor-pointer mr-2"
          [disabled]="isButtonDisabled ? true : !userPermissionList?.SaveAssessmentData"
          (click)="saveImplementationAssessmentData(); $event.stopPropagation()"
        >
          <lucide-icon name="save" size="16" class="text-primary"></lucide-icon>
          Save
        </button>
      </div>
    </mat-expansion-panel-header>
    <div class="row ml-2 mt-1">
      <div class="col-lg-3 mb-4">
        <label class="control-label fw">Reference Number</label>
        <div class="control-label control-input">
          <div class="pound-input">
            <input
              type="text"
              class="w-100"
              [(ngModel)]="assessmentData.referenceNumber"
              placeholder=""
              [disabled]="!userPermissionList?.ReferenceNumber"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-4">
        <label class="control-label fw">Title</label>
        <div class="control-label control-input">
          <div class="pound-input">
            <input
              type="text"
              class="w-100"
              [(ngModel)]="assessmentData.title"
              placeholder=""
              [disabled]="!userPermissionList?.Title"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-4">
        <label class="control-label fw"
          >Topic
          <!-- <span class="stars">*</span> -->
        </label>
        <mat-select
          class="select_border_t3"
          [(ngModel)]="assessmentData.topic"
          [disabled]="!userPermissionList?.Topic"
        >
          <mat-option
            *ngFor="
              let option of interpretationAssessmentDropdownList.topicList
            "
            [value]="option"
          >
            {{ option }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-lg-3 mb-4">
        <label class="control-label fw">Implementation Date</label>
        <div class="input-group input-group-sm">
          <input
            matInput
            [matDatepicker]="ImplementationDate"
            (click)="ImplementationDate.open()"
            class="form-control form-control-sm border-bottom"
            name="ImplementationDate"
            [(ngModel)]="assessmentData.implementationDate"
            [disabled]="!userPermissionList?.ImplementationDate"
          />
          <div class="input-group-append">
            <span
              class="input-group-text fa fa-calendar"
              (click)="ImplementationDate.open()"
            ></span>
          </div>
        </div>
        <mat-datepicker #ImplementationDate></mat-datepicker>
      </div>
      <div class="col-lg-3 mb-4">
        <label class="control-label fw"
          >Implementation Status
          <!-- <span class="stars">*</span> -->
        </label>
        <mat-select
          class="select_border_t3"
          [(ngModel)]="assessmentData.implementationStatus"
          [disabled]="!userPermissionList?.ImplementationStatus"
        >
          <mat-option
            *ngFor="
              let option of interpretationAssessmentDropdownList.implementationStatusList
            "
            [value]="option"
          >
            {{ option }}
          </mat-option>
        </mat-select>
      </div>

      <div class="col-lg-3 mb-4">
        <label class="control-label fw">LBG Materiality</label>
        <mat-select
          class="select_border_t3"
          [(ngModel)]="assessmentData.lbgMateriality"
          [disabled]="!userPermissionList?.LBGMateriality"
        >
          <mat-option
            *ngFor="
              let option of interpretationAssessmentDropdownList.lbgMaterialityList
            "
            [value]="option"
          >
            {{ option }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-lg-3 mb-4">
        <label class="control-label fw">RFB Materiality</label>
        <mat-select
          class="select_border_t3"
          [(ngModel)]="assessmentData.rfbMateriality"
          [disabled]="!userPermissionList?.RFBMateriality"
        >
          <mat-option
            *ngFor="
              let option of interpretationAssessmentDropdownList.rfbMaterialityList
            "
            [value]="option"
          >
            {{ option }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-lg-3 mb-4">
        <label class="control-label fw">LBCM Materiality</label>
        <mat-select
          class="select_border_t3"
          [(ngModel)]="assessmentData.lbcmMateriality"
          [disabled]="!userPermissionList?.LBCMMateriality"
        >
          <mat-option
            *ngFor="
              let option of interpretationAssessmentDropdownList.lbcmMaterialityList
            "
            [value]="option"
          >
            {{ option }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-lg-3 mb-4">
        <label class="control-label fw">Submitter Name</label>
        <div class="pound-input">
          <!-- <input
          type="text"
          class="form-control"
          [(ngModel)]="assessmentData.submitterName"
          [disabled]="!userPermissionList?.SubmitterName"
          (input)="onSelectionChange($event.target.value)"
          placeholder="Enter submitter name"
          /> -->
          <mat-form-field class="example-full-width custom_front_input">
            <input type="text"
                   class="form-control"
                   placeholder="Select or type an option"
                   matInput
                   [(ngModel)]="assessmentData.submitterName"
                   [disabled]="!userPermissionList?.SubmitterName"
                   (input)="onSelectionChange($event.target.value)"
                   [matAutocomplete]="autosub">
            <mat-autocomplete #autosub="matAutocomplete" (optionSelected)="onSelectionChange($event.option.value)">
              <mat-option
              *ngFor="
                let option of submitterList
              "
              [value]="option.value"
            >
              {{ option.name }}
            </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
     
      <!-- <div class="col-lg-3 mb-4">
        <label class="control-label fw">Submitter Name</label>
        <mat-select
          class="select_border_t3"
          [(ngModel)]="assessmentData.submitterName"
          [disabled]="!userPermissionList?.SubmitterName"
          (selectionChange)="onSelectionChange($event)"
        >
          <mat-option
            *ngFor="
              let option of submitterList
            "
            [value]="option.value"
          >
            {{ option.name }}
          </mat-option>
        </mat-select>
      </div> -->
      <div class="col-lg-3 mb-4">
        <label class="control-label fw"> Estimated Impact LBG</label>
        <div class="pound-input">
          <input
            type="text"
            class="w-100"
            [(ngModel)]="assessmentData.estimatedImpactLBG"
            placeholder=""
            [disabled]="!userPermissionList?.EstimatedImpactLBG"
          />
        </div>
      </div>
      <div class="col-lg-3 mb-4">
        <label class="control-label fw">Estimated Impact RFB</label>
        <div class="pound-input">
          <input
            type="text"
            class="w-100"
            [(ngModel)]="assessmentData.estimatedImpactRFB"
            placeholder=""
            [disabled]="!userPermissionList?.EstimatedImpactRFB"
          />
        </div>
      </div>
      <div class="col-lg-3 mb-4">
        <label class="control-label fw"> Estimated Impact LBCM</label>
        <div class="pound-input">
          <input
            type="text"
            class="w-100"
            [(ngModel)]="assessmentData.estimatedImpactLBCM"
            placeholder=""
            [disabled]="!userPermissionList?.EstimatedImpactLBCM"
          />
        </div>
      </div>
    </div>
    <div class="row ml-2 mt-1">
      <div class="col-lg-12" *ngIf="tabName == 'Interpretation'">
        <div class="header-text">
          <span class="control-label fw d-block mb-2">
            Interpretation Details
          </span>
        </div>
        <app-ck-editor-revision
          *ngIf="
            user.fullName != '' && assessmentData.interpretationDetails != ''
          "
          class="ck_editor_min_height"
          [accessType]="accessType"
          [data]="assessmentData.interpretationDetails"
          [userInfo]="user"
          [noteId]="'InterpretationDetails'"
          [editorUsers]="assessmentData.muteInterpretationDetailsUsers"
          [selfAssessmentId]="summaryDetailsId"
          (childVariableChange)="
            onChildVariableChangeMainT3($event, 'InterpretationDetails')
          "
          (saveEditorDate)="onEditorSaveMainT3($event)"
          [isSaveDisable]="!userPermissionList?.InterpretationDetails"
        ></app-ck-editor-revision>
      </div>
      <div class="col-lg-12" *ngIf="tabName == 'Judgement'">
        <div class="header-text">
          <span class="control-label fw d-block mb-2"> Judgement Details </span>
        </div>
        <app-ck-editor-revision
          *ngIf="user.fullName != '' && assessmentData.judgementDetails != ''"
          class="ck_editor_min_height"
          [accessType]="accessType"
          [data]="assessmentData.judgementDetails"
          [userInfo]="user"
          [noteId]="'JudgementDetails'"
          [editorUsers]="assessmentData.muteJudgementDetailsUsers"
          [selfAssessmentId]="summaryDetailsId"
          (childVariableChange)="
            onChildVariableChangeMainT3($event, 'JudgementDetails')
          "
          (saveEditorDate)="onEditorSaveMainT3($event)"
          [isSaveDisable]="!userPermissionList?.judgementDetails"
        ></app-ck-editor-revision>
      </div>
      <div class="col-lg-12" *ngIf="tabName == 'Approach'">
        <div class="header-text">
          <span class="control-label fw d-block mb-2"> Approach Details </span>
        </div>
        <app-ck-editor-revision
          *ngIf="user.fullName != '' && assessmentData.approachDetails != ''"
          class="ck_editor_min_height"
          [accessType]="accessType"
          [data]="assessmentData.approachDetails"
          [userInfo]="user"
          [noteId]="'ApproachDetails'"
          [editorUsers]="assessmentData.muteApproachDetailsUsers"
          [selfAssessmentId]="summaryDetailsId"
          (childVariableChange)="
            onChildVariableChangeMainT3($event, 'ApproachDetails')
          "
          (saveEditorDate)="onEditorSaveMainT3($event)"
          [isSaveDisable]="!userPermissionList?.ApproachDetails"
        ></app-ck-editor-revision>
      </div>
    </div>
    <div class="row ml-2 mt-1">
      <div class="col-lg-12" *ngIf="tabName == 'Interpretation'">
        <div class="header-text">
          <span class="control-label fw d-block mb-2">
            Implementation Comments
          </span>
        </div>
        <app-ck-editor-revision
          *ngIf="
            user.fullName != '' && assessmentData.implementationComments != ''
          "
          class="ck_editor_min_height"
          [accessType]="accessType"
          [data]="assessmentData.implementationComments"
          [userInfo]="user"
          [noteId]="'ImplementationComments'"
          [editorUsers]="assessmentData.muteImplementationCommentsUsers"
          [selfAssessmentId]="summaryDetailsId"
          (childVariableChange)="
            onChildVariableChangeMainT3($event, 'ImplementationComments')
          "
          (saveEditorDate)="onEditorSaveMainT3($event)"
          [isSaveDisable]="!userPermissionList?.ImplementationComments"
        ></app-ck-editor-revision>
      </div>
      <div class="col-lg-12" *ngIf="tabName == 'Judgement'">
        <div class="header-text">
          <span class="control-label fw d-block mb-2">
            Judgement Implementation Comments
          </span>
        </div>
        <app-ck-editor-revision
          *ngIf="
            user.fullName != '' &&
            assessmentData.judgementImplementationComments != ''
          "
          class="ck_editor_min_height"
          [accessType]="accessType"
          [data]="assessmentData.judgementImplementationComments"
          [userInfo]="user"
          [noteId]="'JudgementImplementationComments'"
          [editorUsers]="
            assessmentData.muteJudgementImplementationCommentsUsers
          "
          [selfAssessmentId]="summaryDetailsId"
          (childVariableChange)="
            onChildVariableChangeMainT3(
              $event,
              'JudgementImplementationComments'
            )
          "
          (saveEditorDate)="onEditorSaveMainT3($event)"
          [isSaveDisable]="!userPermissionList?.judgementImplementationComments"
        ></app-ck-editor-revision>
      </div>
      <div class="col-lg-12" *ngIf="tabName == 'Approach'">
        <div class="header-text">
          <span class="control-label fw d-block mb-2">
            Approach Implementation Comments
          </span>
        </div>
        <app-ck-editor-revision
          *ngIf="
            user.fullName != '' &&
            assessmentData.approachImplementationComments != ''
          "
          class="ck_editor_min_height"
          [accessType]="accessType"
          [data]="assessmentData.approachImplementationComments"
          [userInfo]="user"
          [noteId]="'ApproachImplementationComments'"
          [editorUsers]="assessmentData.muteApproachImplementationCommentsUsers"
          [selfAssessmentId]="summaryDetailsId"
          (childVariableChange)="
            onChildVariableChangeMainT3(
              $event,
              'ApproachImplementationComments'
            )
          "
          (saveEditorDate)="onEditorSaveMainT3($event)"
          [isSaveDisable]="!userPermissionList?.approachImplementationComments"
        ></app-ck-editor-revision>
      </div>
    </div>

    <div class="row ml-2 pt-3">
      <div
        class="col-12 d-flex justify-content-between align-items-center gap-1"
      >
        <div class="cursor-pointer" (click)="uploadEvidenceMain()">
          <lucide-icon
            class="text-blue-lucide mr-1"
            size="15"
            name="upload"
          ></lucide-icon>
          <span class="text-blue fw"
            >Upload Evidence - Assessment
            <i
              *ngIf="mainEvidanceLoader"
              class="fa fa-circle-o-notch fa-spin"
              style="font-size: 0.875rem; line-height: 1.5"
            ></i>
          </span>
          <input
            id="uploadEvidanceT3"
            (change)="handleFileInput($event.target.files)"
            type="file"
            multiple
            style="display: none"
          /><br />
        </div>
        <div>
          <span class="mr-1">Ready for Review?</span
          ><input
            type="checkbox"
            [(ngModel)]="assessmentData.readyForReview"
            [disabled]="!userPermissionList?.ReadyForReview"
            (click)="isReadyForReviewClicked($event)"
          />
        </div>
      </div>
      <div
        class="col-lg-12 mt-3"
        *ngIf="selfAssessmentDocument.length > 0 && tabName == 'Interpretation'"
      >
        <ng-container *ngFor="let docs of selfAssessmentDocument">
          <div class="file-div text-center" *ngIf="docs.fileType === 4">
            <span
              class="fa fa-trash pull-right delete-docs"
              (click)="openDeleteModel(docs.id)"
            ></span>
            <span
              class="cursor-pointer"
              (click)="
                downloadDocument(docs.id, docs.fileName, docs.fileExtension)
              "
            >
              <i
                class="fa fa-file-text fa-2x"
                *ngIf="docs.fileExtension === '.txt'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-text-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.eml' || docs.fileExtension === '.msg'
                "
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-pdf-o fa-2x"
                *ngIf="docs.fileExtension === '.pdf'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.doc'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.docx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xls'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xlsx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-o fa-2x"
                *ngIf="docs.fileExtension === '.csv'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-code-o fa-2x"
                *ngIf="docs.fileExtension === '.xml'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-archive-o fa-2x"
                *ngIf="docs.fileExtension === '.zip'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpeg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.png'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-powerpoint-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.ppt' ||
                  docs.fileExtension === '.pptx'
                "
                aria-hidden="true"
              ></i>
            </span>
            <div class="data-div">{{ docs.fileName }}</div>
          </div>
        </ng-container>
      </div>
      <div
        class="col-lg-12 mt-3"
        *ngIf="selfAssessmentDocument.length > 0 && tabName == 'Judgement'"
      >
        <ng-container *ngFor="let docs of selfAssessmentDocument">
          <div class="file-div text-center" *ngIf="docs.fileType === 8">
            <span
              class="fa fa-trash pull-right delete-docs"
              (click)="openDeleteModel(docs.id)"
            ></span>
            <span
              class="cursor-pointer"
              (click)="
                downloadDocument(docs.id, docs.fileName, docs.fileExtension)
              "
            >
              <i
                class="fa fa-file-text fa-2x"
                *ngIf="docs.fileExtension === '.txt'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-text-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.eml' || docs.fileExtension === '.msg'
                "
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-pdf-o fa-2x"
                *ngIf="docs.fileExtension === '.pdf'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.doc'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.docx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xls'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xlsx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-o fa-2x"
                *ngIf="docs.fileExtension === '.csv'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-code-o fa-2x"
                *ngIf="docs.fileExtension === '.xml'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-archive-o fa-2x"
                *ngIf="docs.fileExtension === '.zip'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpeg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.png'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-powerpoint-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.ppt' ||
                  docs.fileExtension === '.pptx'
                "
                aria-hidden="true"
              ></i>
            </span>
            <div class="data-div">{{ docs.fileName }}</div>
          </div>
        </ng-container>
      </div>
      <div
        class="col-lg-12 mt-3"
        *ngIf="selfAssessmentDocument.length > 0 && tabName == 'Approach'"
      >
        <ng-container *ngFor="let docs of selfAssessmentDocument">
          <div class="file-div text-center" *ngIf="docs.fileType === 12">
            <span
              class="fa fa-trash pull-right delete-docs"
              (click)="openDeleteModel(docs.id)"
            ></span>
            <span
              class="cursor-pointer"
              (click)="
                downloadDocument(docs.id, docs.fileName, docs.fileExtension)
              "
            >
              <i
                class="fa fa-file-text fa-2x"
                *ngIf="docs.fileExtension === '.txt'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-text-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.eml' || docs.fileExtension === '.msg'
                "
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-pdf-o fa-2x"
                *ngIf="docs.fileExtension === '.pdf'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.doc'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.docx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xls'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xlsx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-o fa-2x"
                *ngIf="docs.fileExtension === '.csv'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-code-o fa-2x"
                *ngIf="docs.fileExtension === '.xml'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-archive-o fa-2x"
                *ngIf="docs.fileExtension === '.zip'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpeg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.png'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-powerpoint-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.ppt' ||
                  docs.fileExtension === '.pptx'
                "
                aria-hidden="true"
              ></i>
            </span>
            <div class="data-div">{{ docs.fileName }}</div>
          </div>
        </ng-container>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
